import { render, staticRenderFns } from "./EllipsisTooltip.vue?vue&type=template&id=31651256&scoped=true"
import script from "./EllipsisTooltip.vue?vue&type=script&lang=js"
export * from "./EllipsisTooltip.vue?vue&type=script&lang=js"
import style0 from "./EllipsisTooltip.vue?vue&type=style&index=0&id=31651256&prod&scoped=true&lang=css"
import style1 from "./EllipsisTooltip.vue?vue&type=style&index=1&id=31651256&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31651256",
  null
  
)

export default component.exports